import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase environment variables');
  console.error('VITE_SUPABASE_URL:', supabaseUrl ? 'Present' : 'Missing');
  console.error('VITE_SUPABASE_ANON_KEY:', supabaseAnonKey ? 'Present' : 'Missing');
}

// Validate URL format
if (supabaseUrl && !supabaseUrl?.startsWith('http')) {
  console.error('Invalid Supabase URL format. Must start with http:// or https://');
}

// Custom fetch with timeout and graceful error handling
const fetchWithTimeout = (url, options = {}) => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller?.abort(), 15000); // 15s timeout

  return fetch(url, { ...options, signal: controller?.signal })?.then((response) => {
      clearTimeout(timeoutId);
      return response;
    })?.catch((err) => {
      clearTimeout(timeoutId);
      if (err?.name === 'AbortError') {
        throw new Error('Request timed out. Please check your connection.');
      }
      // Suppress "Failed to fetch" from propagating as unhandled — rethrow as a cleaner error
      throw new Error('Network error. Please check your internet connection.');
    });
};

export const supabase = supabaseUrl && supabaseAnonKey
  ? createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true
      },
      global: {
        fetch: fetchWithTimeout
      }
    })
  : null;

// Helper to check if Supabase is configured
export const isSupabaseConfigured = () => {
  return supabase !== null && supabaseUrl && supabaseAnonKey;
};